import { loadView } from '@/helper/utils'
import { plainLayout } from '@/components/layouts/Plain'

export default {
  path: '/line',
  component: plainLayout(loadView('line/Line')),
  children: [
    {
      path: 'oauth',
      name: 'LineOAuth',
      component: loadView('line/LineOAuth')
    },
    {
      path: 'regist',
      name: 'LineRegist',
      component: loadView('line/LineRegist')
    },
    {
      path: 'profile/regist',
      name: 'LineProfileRegist',
      component: loadView('line/LineProfileRegist')
    },
    {
      path: 'no_profile/regist',
      name: 'LineNoProfileRegist',
      component: loadView('line/LineNoProfileRegist')
    },
    {
      path: 'liff/profile/regist',
      name: 'LineLiffProfileRegist',
      component: loadView('line/LineLiffProfileRegist')
    },
    {
      path: 'liff/no_profile/regist',
      name: 'LineLiffNoProfileRegist',
      component: loadView('line/LineLiffNoProfileRegist')
    },
    {
      path: 'top/regist',
      name: 'LineTopRegist',
      component: loadView('line/LineTopRegist')
    }
  ]
}
